'use strict';

function CnHeadAction($q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.performAction = performAction;
  vm.setInactive = setInactive;

  function $onInit() {
    vm.parentController.setActions(true);
    vm.do = vm.do || $q.resolve();
    vm.buttonClass = vm.buttonClass || 'btn btn-default';
    vm.icon = vm.icon || 'fa fa-question';
  }

  function performAction() {
    if (!vm.href) {
      vm.active = true;
      vm.do().finally(setInactive);
    }
  }

  function setInactive() {
    vm.active = false;
  }
}

module.exports = CnHeadAction;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-head/cn-head-action/cn-head-action.controller.js
 ** module id = 41
 ** module chunks = 0
 **/